<!-- 健康在线文章管理 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header flex flexJc-sb flexAi-c  pad">
        <div class="text">健康在线文章管理</div>
        <el-button @click="addShopBut" round type="primary" size="mini"
          >添加文章</el-button
        >
      </div>
      <div class="content">
        <el-table
          height="68vh"
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="ArticlesList"
          style="width: 100%"
        >
          <el-table-column prop="arId" label="ID" width="110">
          </el-table-column>
          <el-table-column prop="arTitle" label="文章标题" width="210">
          </el-table-column>
          <el-table-column prop="categoryName" label="所属栏目" width="160">
          </el-table-column>
          <el-table-column label="产品介绍" width="210">
            <template slot-scope="scope">
              <div class="introduce">
                {{ scope.row.arContent | getText }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              {{ scope.row.arTime | filterTime }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-link
                class="padR10"
                :underline="false"
                type="primary"
                @click="editBut(scope.row)"
                >修改</el-link
              >
              <el-popconfirm
                @confirm="delBut(scope.row)"
                title="这是一段内容确定删除吗？"
              >
                <el-link slot="reference" :underline="false" type="primary"
                  >删除</el-link
                >
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGetArticless, apiDelArticles } from '@/api/articleManage'

export default {
  name: '',
  props: [''],
  data() {
    return {
      ArticlesList: []
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.GetArticless()
  },

  methods: {
    // 添加产品
    addShopBut() {
      this.$router.push({
        path: '/AddhealthArticle'
      })
    },
    // 列表删除
    delBut(row) {
      console.log(row)
      apiDelArticles({
        arId: row.arId
      }).then(res => {
        if (res.status === 0) {
          this.$Ms(res.msg)
          this.GetArticless()
        } else if (res.status === 1) {
          this.$Me(res.msg)
        }
      })
    },
    // 列表修改
    editBut(row) {
      this.$router.push({
        path: '/AddhealthArticle',
        query: {
          info: this.$Base64.encode(JSON.stringify(row))
        }
      })
    },
    // 接口
    // 文章列表
    GetArticless() {
      apiGetArticless().then(res => {
        if (res.status === 0) {
          this.ArticlesList = res.data
          this.ArticlesList.reverse()
        }
        console.log(this.ArticlesList)
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    .text {
      color: #119685;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // 产品介绍
    /deep/ .introduce {
      display: -webkit-box !important;
      -webkit-box-orient: vertical !important;
      -webkit-line-clamp: 3 !important;
      overflow: hidden !important;
      color: #9e9e9e;
    }
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    // 分页
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
</style>
